import { useRef } from 'react';

interface TimerRingProps {
  timeLeft: number;
  duration: number;
}

const PANIC_MSGS: Record<number, string[]> = {
  16: ['倒计时开始…别紧张（才怪）😏', '20秒倒计时，够换一片尿布吗？'],
  14: ['已经开始慌了？这题可还没读完呢 📖'],
  12: ['过半了！手指准备好随时开点 🫵', '时间不多了，瞎蒙也要快啊！'],
  10: ['进度告急！！神气值正在流失 💧', '半程已过，你的大脑还在加载中… 🧠💨'],
  8: ['快！娃的耐心只剩一半了！！😤', '手心出汗了吗？正常，我也紧张 👀'],
  6: ['还剩6秒！！随便选一个都比超时强 🎲', '急了急了急了急了 😰'],
  4: ['神气值即将归零！！📉💀', '完了完了完了！！娃已经准备开哭了 😭'],
  2: ['闭眼选C！！！！！🤞🤞🤞', '最后一击！肾上腺爆表！！🧨💣'],
};

export default function TimerRing({ timeLeft, duration }: TimerRingProps) {
  const lastMsgRef = useRef({ bracket: 0, time: 0, msg: '' });

  const sec = Math.ceil(timeLeft);
  const progress = timeLeft / duration;
  const circ = 2 * Math.PI * 32;

  const danger = timeLeft <= 8;
  const warn = timeLeft <= 14 && !danger;

  let fgClass = '';
  if (danger) fgClass = 'danger';
  else if (warn) fgClass = 'warn';

  // Panic message
  const PANIC_BRACKETS = [16, 14, 12, 10, 8, 6, 4, 2];
  let bracket = 0;
  for (const b of PANIC_BRACKETS) {
    if (sec <= b && sec > b - 2) { bracket = b; break; }
  }

  let panicText = '';
  if (bracket) {
    const now = Date.now();
    if (bracket !== lastMsgRef.current.bracket || now - lastMsgRef.current.time > 2500) {
      const msgs = PANIC_MSGS[bracket] || PANIC_MSGS[8];
      lastMsgRef.current = { bracket, time: now, msg: msgs[Math.floor(Math.random() * msgs.length)] };
    }
    panicText = lastMsgRef.current.msg;
  } else {
    lastMsgRef.current = { bracket: 0, time: 0, msg: '' };
  }

  // Panic emoji display
  let displayText = String(sec);
  if (danger && sec % 2 === 0) {
    const panicWords = ['💀', '🆘', '😱', '⏰', '🔥'];
    displayText = panicWords[Math.floor(Math.random() * panicWords.length)];
  }

  return (
    <div className="timer-section">
      <div className={`timer-ring-wrap${danger ? ' urgent' : ''}`}>
        <svg viewBox="0 0 80 80">
          <circle className="timer-bg" cx="40" cy="40" r="32" />
          <circle
            className={`timer-fg${fgClass ? ' ' + fgClass : ''}`}
            cx="40" cy="40" r="32"
            strokeDasharray={circ}
            strokeDashoffset={circ * (1 - progress)}
          />
        </svg>
        <div className="timer-text">{displayText}</div>
      </div>
      <div className={`panic-bar${bracket && timeLeft <= 15 ? ' active' : ''}`}>
        {panicText}
      </div>
    </div>
  );
}
